import { api } from './axios';
import type { Competition, User } from '../types/domain';

export const recorderAssignmentApi = {
  list: (competitionId: number) =>
    api.get<User[]>(`/admin/competitions/${competitionId}/recorders`).then((r) => r.data),
  assign: (competitionId: number, userId: number) =>
    api.post(`/admin/competitions/${competitionId}/recorders`, { userId }),
  remove: (competitionId: number, userId: number) =>
    api.delete(`/admin/competitions/${competitionId}/recorders/${userId}`),
};

export const recorderApi = {
  myCompetitions: () => api.get<Competition[]>('/recorder/competitions').then((r) => r.data),
};

export const adminUsersApi = {
  list: () => api.get<User[]>('/admin/users').then((r) => r.data),
};
